import { Badge } from "V2.0/common/badge";

export const PipelineV2RunStatus = {
  FAILED: "failed",
  PAUSED: "paused",
  CANCELLED: "cancelled",
  RUNNING: "running",
  SCHEDULED: "scheduled",
  COMPLETED: "completed",
} as const;

export type PipelineV2RunStatus = (typeof PipelineV2RunStatus)[keyof typeof PipelineV2RunStatus]

export const PipelineV2RunStatusBadgeRegistry = {
  [PipelineV2RunStatus.FAILED]: <Badge color="red">Failed</Badge>,
  [PipelineV2RunStatus.PAUSED]: <Badge color="amber">Paused</Badge>,
  [PipelineV2RunStatus.CANCELLED]: <Badge color="red">Cancelled</Badge>,
  [PipelineV2RunStatus.RUNNING]: <Badge color="amber">Running</Badge>,
  [PipelineV2RunStatus.SCHEDULED]: <Badge color="orange">Scheduled</Badge>,
  [PipelineV2RunStatus.COMPLETED]: <Badge color="emerald">Completed</Badge>,
} as const;

export const renderDefaultBadge = (status) => <Badge>status</Badge>;
